import { Component } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'demo-upp-panel',
    templateUrl: './demo-upp-panel.html',
    styleUrls: ['../demo-common.scss', './demo-upp-panel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppPanelComponent {
    panelLines: 'show' | 'hide' = 'hide';
    panelSizes: Array<'small' | 'auto' | 'large'> = ['small', 'auto', 'large'];

    cards = [
        { title: "Today's Sales", value: '€1,245', label: 'Revenue today', color: 'success', icon: 'cash-outline' },
        { title: 'Active Orders', value: '38', label: 'Orders in progress', color: 'primary', icon: 'receipt-outline' },
        { title: 'Low Stock Alerts', value: '7', label: 'Items below threshold', color: 'warning', icon: 'alert-circle-outline' }
    ];

    toggleLines() {
        this.panelLines = this.panelLines === 'show' ? 'hide' : 'show';
    }

    cycleSize(index: number) {
        const sizes: Array<'small' | 'auto' | 'large'> = ['small', 'auto', 'large'];
        const current = sizes.indexOf(this.panelSizes[index]);
        this.panelSizes[index] = sizes[(current + 1) % sizes.length];
    }
}
